import { Injectable } from '@angular/core';
import { ServiceCacheData } from '../models/common/serviceCacheData';
import { DateHelper } from '../helpers/DateHelper';

@Injectable()
export class CacheService {

	private cacheData: ServiceCacheData[] = [];

	constructor() { }

	add(key: string, value: any, keepTime: number) {
		if (this.cacheData.findIndex(x => x.key == key) != -1) {
			return;
		}

		let temp = new ServiceCacheData();
		temp.key = key;
		temp.value = value;
		temp.keepTime = keepTime;

		this.cacheData.push(temp);
	}

	get(key: string) {
		let index = this.cacheData.findIndex(x => x.key == key);
		if (index == -1) {
			return null;
		}

		let temp = this.cacheData[index];
		if (temp.key == key) {
			if (DateHelper.getTimeDifferenceInSeconds(temp.insertTime, new Date()) <= temp.keepTime) {
				return temp.value;
			}

			//destroy
			this.cacheData.splice(index, 1);
			return null;
		}
	}

	remove(key: string){
		let index = this.cacheData.findIndex(x => x.key == key);
		if (index >= 0) {
			this.cacheData.splice(index, 1);
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/services/cache.service.ts